import { Tabs } from '@delmonicos/shared-design-system-react/src/components/tab/tabs.component';
import {
  extractTabKeys,
  useTabQuery,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/hooks';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { CustomerNetworkListControllerWithContext } from '../customer-network-list/customer-network-list.controller';
import { CustomerUserListControllerWithContext } from '../customer-user-list/customer-user-list.controller';
import { InformationTabView } from './information-tab/information-tab.view';

enum TabEnum {
  INFORMATION = 'information',
  USERS = 'users',
  NETWORKS = 'networks',
}

export const CustomerDetailsView = (): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  // Nothing to do

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // TABS //////////////////////////////////////////////////////////////////////

  const tabs = useMemo(
    () =>
      [
        {
          title: t('$.customer-details.information.title'),
          key: TabEnum.INFORMATION,
          icon: 'info-circle',
        },
        {
          title: t('$.user-list.title'),
          key: TabEnum.USERS,
          icon: 'users-01',
        },
        {
          title: t('$.network-list.title'),
          key: TabEnum.NETWORKS,
          icon: 'server-06',
        },
      ] as const,
    [t],
  );

  const { tab: currentTab, setTab: setCurrentTab } = useTabQuery(
    TabEnum.INFORMATION,
    extractTabKeys(tabs),
  );

  const renderTab = useMemo(() => {
    switch (currentTab) {
      case TabEnum.USERS:
        return <CustomerUserListControllerWithContext />;
      case TabEnum.NETWORKS:
        return <CustomerNetworkListControllerWithContext />;
      case TabEnum.INFORMATION:
      default:
        return <InformationTabView />;
    }
  }, [currentTab]);

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <>
      <Tabs
        currentTab={currentTab}
        onTabClick={(tab) => setCurrentTab(tab)}
        elements={tabs}
      />
      {renderTab}
    </>
  );
};
